window.Balance = (function () {
    var dom = {};
    var isVisibleViewBalance;
    var selectors = {
        viewBalanceIcon: '[js-node="view-balance__button"]',
        viewBalanceSum: '[js-node="view-balance__sum"]',
        viewBonusSum: '[js-node="view-bonus__sum"]',
        viewBalanceInput: '[js-node="view-balance__input"]',
        viewBalanceByIdButton: '.js-view-balance-by-id__button'
    };

    return {
        init: function () {
            if (!isVisibleViewBalance) {
                isVisibleViewBalance = window.globalAppSettings.showBalance;
            }

            if (isVisibleViewBalance === false) {
                $(selectors.viewBalanceByIdButton).show();
            }

            this.bindUI();
        },
        update: function () {
            if (isVisibleViewBalance === true) {
                this.showBalance();
            }
            else {
                this.hideBalance();
            }

        },
        bindUI: function () {
            var self = this;
            $(document).on('click', selectors.viewBalanceIcon, function () {
                document.dispatchEvent(new CustomEvent('changeBalanceVisibility', {
                    detail: {
                        isVisibleViewBalance: !isVisibleViewBalance,
                    }
                }))
            });
            document.addEventListener('changeBalanceVisibility', function (e) {
                if(e?.detail?.isVisibleViewBalance === undefined) throw new Error('No value specified');
                self.changeViewBalanceUI(e.detail.isVisibleViewBalance);
                self.saveViewBalanceState(e.detail.isVisibleViewBalance);
            });
            $(document).on('click', selectors.viewBalanceByIdButton, function (e) {
                e.stopPropagation();
            }).on('mousedown', selectors.viewBalanceByIdButton, function () {
                var id = $(this).attr('view-balance-button');

                $('[view-balance-sum="' + id + '"]').each(function () {
                    $(this).removeClass('m-hidden');
                });
            }).on('mouseup mouseleave', selectors.viewBalanceByIdButton, function (e) {
                var id = $(this).attr('view-balance-button');

                $('[view-balance-sum="' + id + '"]').each(function () {
                    $(this).addClass('m-hidden');
                });
            });
        },
        changeViewBalanceUI: function (ViewBalanceState) {
            isVisibleViewBalance = ViewBalanceState;

            if (isVisibleViewBalance) {
                this.showBalance();
            } else {
                this.hideBalance();
            }
            var profileCheckbox = document.getElementById('balance-checkbox');
            if (profileCheckbox != null) {
                profileCheckbox.checked = !isVisibleViewBalance;
            }
        },
        showBalance: function () {
            //Баланс
            $(selectors.viewBalanceSum).each(function () {
                $(this).removeClass('m-hidden');
            });

            //Бонусные баллы
            $(selectors.viewBonusSum).each(function () {
                $(this).removeClass('m-hidden');
            });

            $(selectors.viewBalanceInput).each(function () {
                $(this).attr('type', 'text');
            });

            $(selectors.viewBalanceIcon).addClass('m-hide');
            $(selectors.viewBalanceByIdButton).hide();
        },
        hideBalance: function () {
            $(selectors.viewBalanceSum).each(function () {
                $(this).addClass('m-hidden');
            });

            $(selectors.viewBonusSum).each(function () {
                $(this).addClass('m-hidden');
            });

            $(selectors.viewBalanceInput).each(function () {
                $(this).attr('data-sum', $(this).val());
                $(this).attr('type', 'password');
            });

            $(selectors.viewBalanceIcon).removeClass('m-hide');
            $(selectors.viewBalanceByIdButton).show();
        },

        getIntBalance: function () {
            var sumWrapper = $(selectors.viewBalanceSum);
            if (sumWrapper.length > 0) {
                var res = parseInt(sumWrapper.text().replace(/[\u00a0\s]/g, ''));
                return res;
            }
            else return undefined;
        },

        saveViewBalanceState: function (ViewBalanceState) {
           $.ajax('/account/profile/edit/changebalancevisibility', {
                type: "POST",
                data: { isBalanceVisible: ViewBalanceState },
            });
        }
    }
}());